import type { ComponentPropsWithoutRef } from 'react';

import { cn } from '@/lib/utils';

export type FieldSetProps = ComponentPropsWithoutRef<'fieldset'>;

const FieldSet = ({ className, ...props }: FieldSetProps) => {
  return (
    <fieldset
      data-slot="field-set"
      className={cn(
        'flex flex-col gap-4 has-[>[data-slot=checkbox-group]]:gap-3 has-[>[data-slot=radio-group]]:gap-3',
        className,
      )}
      {...props}
    />
  );
};

export default FieldSet;
